import { type CheckboxProps, FormHelperText } from '@mui/material';
import { Checkbox } from 'components/Checkbox';
import type { FC, ReactNode } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

type Props = {
  label: string | ReactNode;
} & CheckboxProps;

export const CheckboxWithLabel: FC<Props> = ({ label, ...other }) => {
  const { control } = useFormContext();

  const { name } = { ...other };

  return (
    <Controller
      name={name ?? ''}
      control={control}
      render={({ field, fieldState }) => (
        <div>
          {/* biome-ignore lint/a11y/noLabelWithoutControl: The checkbox is in the label, so it's fine */}
          <label style={{ display: 'flex', flexDirection: 'row', gap: 1, alignItems: 'center' }}>
            <Checkbox {...field} {...other} label={label} />
          </label>
          {fieldState.error && <FormHelperText error>{fieldState.error.message}</FormHelperText>}
        </div>
      )}
    />
  );
};
